import axios from 'axios';
import { API_URL } from 'configs';


export const EMP_CAMPAIGNS_SUCCESS = 'EMP_CAMPAIGNS_SUCCESS';
export const EMP_DEPARTMENTS_SUCCESS = 'EMP_DEPARTMENTS_SUCCESS';
export const EMP_DESIGNATIONS_SUCCESS = 'EMP_DESIGNATIONS_SUCCESS';

const SHOW_LOADER = 'SHOW_LOADER';
const HIDE_LOADER = 'HIDE_LOADER'; 
const SHOW_SNACKBAR = 'SHOW_SNACKBAR';

const showCommonLoader = (label = '') => ({
	type: SHOW_LOADER,
	common_loder_label: label
});

const hideCommonLoader = () => ({
	type: HIDE_LOADER
});


const tokenError = notification => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: notification,
  snackbar_notification_type: 'token_expire'
})

const showGeneralError = notification => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: notification,
  snackbar_notification_type: 'general_error'
})

export const fetchEmployeeCampaigns = () => {
  const token = localStorage.getItem("token");

  return dispatch => {
    dispatch(showCommonLoader());
    
    return axios(`${API_URL}employees/campaigns`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer ' + token
      }
    })
    .then(response => {
      dispatch(hideCommonLoader());
      dispatch({ type: EMP_CAMPAIGNS_SUCCESS, payload: response.data });
    })
    .catch(error => {
      dispatch(hideCommonLoader());
      handleErrorResponse(error, dispatch);
    });
  };
};

export const fetchEmployeeDepartments = () => {
  const token = localStorage.getItem("token");

  return dispatch => {
    dispatch(showCommonLoader());

    return axios(`${API_URL}employees/departments`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer ' + token
      }
    })
    .then(response => {
      dispatch(hideCommonLoader());
      dispatch({ type: EMP_DEPARTMENTS_SUCCESS, payload: response.data });
    })
    .catch(error => {
      dispatch(hideCommonLoader());
      handleErrorResponse(error, dispatch);
    });
  };
};

export const fetchEmployeeDesignations = () => {
  const token = localStorage.getItem("token");

  return dispatch => {
    dispatch(showCommonLoader());

    return axios(`${API_URL}employees/designations`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer ' + token
      }
    })
    .then(response => {
      dispatch(hideCommonLoader());
      dispatch({ type: EMP_DESIGNATIONS_SUCCESS, payload: response.data });
    })
    .catch(error => {
      dispatch(hideCommonLoader());
      handleErrorResponse(error, dispatch);
    });
  };
};

 
const handleErrorResponse = (error, dispatch) => {
  try {
    if (error.response.status === 401 && error.response.data.error) {
      dispatch(tokenError(error.response.data.error.toString()))
    }
    else {
      /*let err = '';
      if (error.response.data.error) {
        err = error.response.data.error.toString()
      }
      else {
        err = error.response.status + ` ` + error.response.statusText
      }
      //dispatch(clockinFailure(err)*/
    }
  }
  catch (e) {
    //dispatch(clockinFailure('Unable to perform action.Something went wrong'))
  }
}  